import React from 'react'
import LeagueRegister from '../components/LeagueRegister/LeagueRegister'

function WizardPage_v2(props) {
    return (
        <LeagueRegister />
    )
}


export default WizardPage_v2
